const extend = require('extend');
const Q = require('q');
const _ = require('underscore');
const to_int = require('../convert/to_int');

/**
 * NL类库
 *
 * @module NL
 */

/**
 * NL.pagerHelper
 * <div>
 * <span class="tag margin-right">支持浏览器环境</span>
 * <span class="tag margin-right">支持node环境</span>
 * </div>
 *
 * @class NL.pagerHelper
 * @static
 *
 */

/**
 * 获取分页数据
 *
 * @method get_pager_data
 * @param {object} pValue 要判断的原始数据
 * @return {boolean} 是否为int类型的数据
 *
 * @demo src/convert/demo/is_int.demo.js
 */

const get_pager_data = function (pParameter) {
    if (!pParameter) pParameter = {};
    const list_all = pParameter.list_all || [];
    const __page_index = pParameter.page_index;
    const __page_size = pParameter.page_size;

    let page_index = to_int(__page_index, 1);
    let page_size = to_int(__page_size, 10);
    if (page_index <= 1) page_index = 1;
    if (page_size <= 0) page_size = 10;

    const record_count = list_all.length;
    const page_count = Math.ceil(record_count / page_size);
    if (page_index > page_count) {
        page_index = page_count;
    }

    const start_index = (page_index - 1) * page_size;
    const end_index = start_index + page_size - 1;

    const list = _.chain(list_all)
        .filter(function (m, i) {
            return 1 === 1
                && i >= start_index
                && i <= end_index
                ;
        })
        .value()
    ;

    const pager_data = {};
    pager_data.page_index = page_index;
    pager_data.page_size = page_size;
    pager_data.record_count = record_count;
    pager_data.page_count = page_count;
    pager_data.list = list;
    pager_data.list_all = list_all;

    return pager_data;
};

module.exports = get_pager_data;
